import React from "react"

import {
  Container,
  ColumnA,
  ColumnB,
  Heading,
  Row,
  ContentWrapper,
  ImageWrapper,
  Description,
} from "./CommonSection.styles"

const CommonSection = ({ title, description, children }) => {
  return (
    <Container>
      <Row imgStart={false}>
        <ColumnA>
          <ContentWrapper>
            <Heading>{title}</Heading>
            <Description>{description}</Description>
          </ContentWrapper>
        </ColumnA>
        <ColumnB>
          <ImageWrapper>{children}</ImageWrapper>
        </ColumnB>
      </Row>
    </Container>
  )
}

export default CommonSection
